import { redirect } from "@tanstack/react-router"
import type { AccessState, KnownBlockedReason } from "../model/access-state"

const BLOCKED_RULES: Record<
	KnownBlockedReason,
	{ redirectTo: string; allowedPaths?: string[]; allowedPrefix?: string }
> = {
	email_not_verified: {
		redirectTo: "/onboarding/signup-email-verification",
		allowedPrefix: "/onboarding/signup-email",
	},
	parental_consent: {
		redirectTo: "/onboarding/signup-age-restricted",
		allowedPaths: ["/onboarding/signup-age-restricted"],
	},
	need_age_verification: {
		redirectTo: "/onboarding/signup-date-of-birth",
		allowedPaths: [
			"/onboarding/signup-date-of-birth",
			"/onboarding/signup-age-restricted",
		],
	},
	blocked: { redirectTo: "/user-blocked", allowedPaths: ["/user-blocked"] },
	system_blocked: {
		redirectTo: "/user-blocked",
		allowedPaths: ["/user-blocked"],
	},
	temp_blocked: {
		redirectTo: "/user-blocked",
		allowedPaths: ["/user-blocked"],
	},
}

export function getRedirectTargetForAccessState(
	accessState: AccessState,
): string | null {
	if (accessState.kind === "authenticated") return "/home"
	if (accessState.kind !== "blocked") return null

	return BLOCKED_RULES[accessState.reason].redirectTo
}

function isPathAllowed(
	pathname: string,
	rule: { allowedPaths?: string[]; allowedPrefix?: string },
): boolean {
	if (rule.allowedPrefix && pathname.startsWith(rule.allowedPrefix)) return true
	return rule.allowedPaths?.includes(pathname) ?? false
}

export function enforceAccessPolicy(
	accessState: AccessState,
	pathname: string,
): void {
	if (accessState.kind !== "blocked") return

	const rule = BLOCKED_RULES[accessState.reason]

	if (!isPathAllowed(pathname, rule)) {
		throw redirect({ to: rule.redirectTo })
	}
}
